<script setup lang="ts">
// Authenticated member shell — top bar + role-filtered sidenav (doc 04 §9.1).
import AppTopBar from '@/components/layout/AppTopBar.vue'
import AppSidebar from '@/components/layout/AppSidebar.vue'
</script>

<template>
  <AppTopBar />
  <AppSidebar />
  <v-main>
    <v-container fluid class="pa-6">
      <slot />
    </v-container>
  </v-main>
</template>
